import React from 'react';

const ConfiguratorPrivate = ({ filled, color = 'currentColor' }: { filled?: boolean; color?: string }) => {
  if (filled) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.84 6.42V5.09H9.94V6.42H12.84Z" fill={color} />
        <path
          d="M21.3731 11H19.8056L20.51 12.22H21.97L21.3731 11Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.94 6.42H6.84C6.23101 6.4747 5.67779 6.79711 5.33 7.3L4.14 9.82C6.04 10.04 7.95 10.2 9.85 10.2V11.56C7.76 11.5 5.66 11.35 3.57 11.1L2.84 12.76V12.93C2.712 13.1441 2.33616 13.3676 1.9482 13.5983C1.45959 13.8889 0.951738 14.1909 0.895471 14.5C2.43547 14.71 5.39 14.89 7.03 15L6.92 16.31C5.28 16.19 2.38 16.02 0.84 15.81L2.15 21.48C2.15 21.6346 2.27536 21.76 2.43 21.76H4.43C4.59186 21.7601 4.7246 21.6318 4.73 21.47V19.66H18.91V21.48C18.91 21.6346 19.0354 21.76 19.19 21.76H21.19C21.3424 21.7548 21.4648 21.6324 21.47 21.48V15.78C19.97 15.99 18.41 16.16 16.81 16.28L16.71 14.96C18.32 14.84 19.88 14.66 21.38 14.45C21.2847 13.9112 21.0879 13.3954 20.8 12.93L20.75 12.85V12.76L20.51 12.22L19.8056 11H12.84V6.42H9.94ZM12.84 15.95C12.84 16.5023 12.3923 16.95 11.84 16.95C11.2877 16.95 10.84 16.5023 10.84 15.95C10.84 15.3977 11.2877 14.95 11.84 14.95C12.3923 14.95 12.84 15.3977 12.84 15.95Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.97 12.22H20.51L20.75 12.76V12.85L20.8 12.93C21.0879 13.3954 21.2847 13.9112 21.38 14.45L22.7154 14.0922C22.8123 14.5977 22.8377 14.8853 22.84 15.4129L21.47 15.78V21.48C21.4648 21.6324 21.3424 21.7548 21.19 21.76H19.19C19.0354 21.76 18.91 21.6346 18.91 21.48V19.66H4.73V21.47C4.7246 21.6318 4.59186 21.7601 4.43 21.76H2.43C2.27536 21.76 2.15 21.6346 2.15 21.48L0.84 15.81V21.48C0.84 22.3692 1.56082 23.09 2.45 23.09H4.45C5.34633 23.09 6.0745 22.3663 6.08 21.47V21H17.62V21.49C17.62 22.3792 18.3408 23.1 19.23 23.1H21.23C22.1208 23.0945 22.84 22.3708 22.84 21.48V15.4129V15.29C22.8396 14.8857 22.7975 14.4844 22.7154 14.0922C22.5773 13.4327 22.3261 12.799 21.97 12.22ZM0.84 15.29V15.3047C0.84 15.3047 0.837354 15.1021 0.852728 14.9186C0.844582 15.042 0.840322 15.1658 0.84 15.29ZM0.852728 14.9186C0.861983 14.7784 0.876255 14.6387 0.895471 14.5C0.895471 14.5 0.868102 14.735 0.852728 14.9186ZM0.895471 14.5C0.951738 14.1909 1.45959 13.8889 1.9482 13.5983C2.33616 13.3676 2.712 13.1441 2.84 12.93V12.76L3.57 11.1C5.66 11.35 7.76 11.5 9.85 11.56V10.2C7.95 10.2 6.04 10.04 4.14 9.82L5.33 7.3C5.67779 6.79711 6.23101 6.4747 6.84 6.42H9.94V5.09H6.75C5.6845 5.17473 4.72288 5.76136 4.16 6.67L2.84 9.66C1.96667 9.55333 1.09667 9.42333 0.23 9.27H0.17L0.06 9.93L0 10.59C0.76 10.72 1.52 10.83 2.29 10.94L1.71 12.23C1.28281 12.9246 1.00655 13.6979 0.895471 14.5Z"
          fill={color}
        />
        <path
          d="M17.44 8.41L15.45 6.42H14.17V9.67H19.0378L17.9917 7.85825L17.44 8.41Z"
          fill={color}
        />
        <path
          d="M14.97 5.94L15.82 5.09H14.17V6.42H15.45L14.97 5.94Z"
          fill={color}
        />
        <path
          d="M20.97 3L21.91 3.94L19.23 6.62L20.7223 9.67H22.51V1.33H14.17V5.09H15.82L15.91 5L16 5.09H18.88L20.97 3Z"
          fill={color}
        />
        <path
          d="M17.348 6.43805L17.5157 6.45426L18.88 5.09H16L17.348 6.43805Z"
          fill={color}
        />
        <path
          d="M19.23 6.62L17.9917 7.85825L19.0378 9.67H20.7223L19.23 6.62Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.82 5.09H16L15.91 5L15.82 5.09Z"
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1302 5.94L17.6002 8.41L22.0702 3.94L21.1302 3L17.6002 6.53L16.0702 5L15.1302 5.94Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0002 0H24.0002V11H13.0002V0ZM22.6702 9.67V1.33H14.3302V9.67H22.6702Z"
        fill={color}
      />
      <path
        d="M20.6702 12.22H22.1302C22.6981 13.1434 22.9992 14.206 23.0002 15.29V21.48C23.0002 22.3708 22.2809 23.0945 21.3902 23.1H19.3902C18.501 23.1 17.7802 22.3792 17.7802 21.49V21H6.24016V21.47C6.23466 22.3663 5.50649 23.09 4.61016 23.09H2.61016C1.72098 23.09 1.00016 22.3692 1.00016 21.48V15.29C1.00296 14.2094 1.30402 13.1505 1.87016 12.23L2.45016 10.94C1.68016 10.83 0.920156 10.72 0.160156 10.59L0.220156 9.93L0.330156 9.27H0.390156C1.25682 9.42333 2.12682 9.55333 3.00016 9.66L4.32016 6.67C4.88304 5.76136 5.84466 5.17473 6.91016 5.09H10.1002V6.42H7.00016C6.39117 6.4747 5.83795 6.79711 5.49016 7.3L4.30016 9.82C6.20016 10.04 8.11016 10.2 10.0102 10.2V11.56C7.92016 11.5 5.82016 11.35 3.73016 11.1L3.00016 12.76V12.93C2.71095 13.4137 2.5111 13.9455 2.41016 14.5C3.95016 14.71 5.55016 14.89 7.19016 15L7.08016 16.31C5.44016 16.19 3.85016 16.02 2.31016 15.81V21.48C2.31016 21.6346 2.43552 21.76 2.59016 21.76H4.59016C4.75201 21.7601 4.88476 21.6318 4.89016 21.47V19.66H19.0702V21.48C19.0702 21.6346 19.1955 21.76 19.3502 21.76H21.3502C21.5026 21.7548 21.625 21.6324 21.6302 21.48V15.78C20.1302 15.99 18.5702 16.16 16.9702 16.28L16.8702 14.96C18.4802 14.84 20.0402 14.66 21.5402 14.45C21.4448 13.9112 21.248 13.3954 20.9602 12.93L20.9102 12.85V12.76L20.6702 12.22Z"
        fill={color}
      />
      <path
        d="M12.0002 16.95C12.5524 16.95 13.0002 16.5023 13.0002 15.95C13.0002 15.3977 12.5524 14.95 12.0002 14.95C11.4479 14.95 11.0002 15.3977 11.0002 15.95C11.0002 16.5023 11.4479 16.95 12.0002 16.95Z"
        fill={color}
      />
    </svg>
  );
};

export default ConfiguratorPrivate;
